import {
  IAnalyticsEvent,
  IAnalyticsEventsTracker,
} from '@verv-inc/js-toolkit/core-analytics';
import { trackAmplitude } from '../../../analytics/amplitude';
import { routeMarketingEvent } from '../../../analytics/marketingRouter';
import { resolvePageAndPaymentVersion } from '../../scripts/paymentVersion';
import { getFirstScreenFromURL } from '../../scripts/firstScreen';

const AMPLITUDE_DENY_ACTIONS = new Set([
  'get_content_ids',
  'complete_payment',
  'add_to_cart',
]);

const AMPLITUDE_DENY_EVENT_NAMES = new Set([
  'gtm-purchase',
]);

export const AmplitudeEventsTracker = (): IAnalyticsEventsTracker => {
  return {
    async track(event: IAnalyticsEvent) {
      if (!event?.name || !event?.info) {
        return;
      }
      const {
        __skipAmplitude,
        ...eventInfo
      } = event.info as IAnalyticsEvent['info'] & { __skipAmplitude?: boolean };
      const { quiz_action } = eventInfo;

      let amplitudeEventName: string | null = null;
      let amplitudeProps = { ...eventInfo };

      // ---------------------------
      // Amplitude routing
      // ---------------------------
      if (AMPLITUDE_DENY_EVENT_NAMES.has(event.name)) {
        amplitudeEventName = null;
      } else if (event.name === 'AB_TEST') {
        amplitudeEventName = 'AB_TEST';
      } else if (
        quiz_action &&
        !AMPLITUDE_DENY_ACTIONS.has(quiz_action)
      ) {
        amplitudeEventName = quiz_action;
        delete amplitudeProps.quiz_action;
      } else if (!quiz_action) {
        amplitudeEventName = event.name;
      }

      // Private mode / quota errors must not break the tracking chain.
      let link: string | null = null;
      try {
        link = localStorage.getItem('link');
      } catch (_) {
        link = null;
      }
      // Only themed funnels send it (currently config=customV77) — absence is normal.
      const firstScreen = getFirstScreenFromURL();
      if (amplitudeEventName) {
        amplitudeProps = {
          ...amplitudeProps,
          link: resolvePageAndPaymentVersion() ?? link,
          ...(firstScreen ? { first_screen: firstScreen } : {}),
        };
      }

      if (
        !__skipAmplitude &&
        amplitudeEventName
      ) {
        trackAmplitude(amplitudeEventName, amplitudeProps);
      }

      // ---------------------------
      // Marketing routing (FB / TikTok / Google Ads)
      // ---------------------------
      routeMarketingEvent({
        name: event.name,
        info: eventInfo,
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        ...(eventInfo ?? {}),
        event: event.name,
      });
    },
  };
};
